
    import '/Users/lijixiang/Work/power-design/site/docs/mobile/avatar-tag.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-avatar-tag-demo-avatar-tag"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/avatar-tag.md?type=demo')
};